import {Avatar, Box, Typography} from "@mui/material";

const PageHeader = ({title, subtitle, icon}) => (
    <Box
        sx={{
            display: "flex",
            alignItems: "center",
            gap: 2.5,
            mb: 3,
            bgcolor: "rgba(63, 81, 181, 0.05)",
            p: 3,
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
            border: "1px solid",
            borderColor: "primary.light",
            borderTop: "4px solid",
            borderTopColor: "primary.main",
        }}
    >
        {icon && (
            <Avatar
                sx={{
                    width: 56,
                    height: 56,
                    bgcolor: "primary.main",
                    boxShadow: "0 4px 12px rgba(63, 81, 181, 0.3)",
                    fontSize: 28,
                }}
            >
                {icon}
            </Avatar>
        )}
        <Box>
            <Typography
                variant="h5"
                sx={{
                    fontWeight: 700,
                    color: "text.primary",
                    mb: subtitle ? 0.5 : 0,
                }}
            >
                {title}
            </Typography>
            {subtitle && (
                <Typography variant="body2" color="text.secondary" sx={{fontWeight: 500}}>
                    {subtitle}
                </Typography>
            )}
        </Box>
    </Box>
);

export default PageHeader;
